import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listAll (URL, header, body, success, error) {
    Vue.axios.post(URL + 'vendor/v1/list/vendor', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeVendor (URL, header, body, success, error) {
    Vue.axios.post(URL + 'vendor/v1/remove/vendor', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  AddVendor (URL, header, body, success, error) {
    Vue.axios.post(URL + 'vendor/v1/add/vendor', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateVendor (URL, header, body, success, error) {
    Vue.axios.post(URL + 'vendor/v1/update/vendor', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_vendor.js